export default "<div class=\"flx-fill\">\r\n    <navigation></navigation>\r\n</div>\r\n";